export default __webpack_public_path__ + "static/media/g-witcher.e4836fb8.jpg";